import styled from "styled-components";
import { color, typeStyle, units } from "@m/alchemy-theme";
export const DialogHeader = styled.header `
  margin-bottom: ${units(1.5)};
  width: 100%;
  text-align: ${({ isCentered }) => (isCentered ? "center" : "left")};
  ${typeStyle("headerS")};
  color: ${color("typeHeader")};
`;
